import { makeStyles, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableRow, Tabs, Typography } from "@material-ui/core"
import React, { useState } from "react"
import { TabPanel } from "./AppEn"

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        height: '100%',
    },
    table: {
        maxWidth: 900,
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        maxHeight: '600px'
    },
}))

export const XronodiagrammaParadoteonEn = () => {
    const classes = useStyles()
    const [activeTab, setActiveTab] = useState(0)

    return (
        <React.Fragment>
            <Typography variant='h5'>Deliverables</Typography>
            <ul>
                <li>
                    <Typography align='justify'>
                        <b>D1.1</b> Report on the olive oil, edible olive and, olive leaf samples to be collected. Creation of an electronic recording and coding system for all samples
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D1.2</b> Report on the PDO & PGI olive oil samples that will be produced. Development of a protocol with the optimal olive oil production conditions
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D2.1</b> Report on the development of specific genetic protocol for the identification of Greek olive varieties
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D2.2</b> Report on the development of the most appropriate methodology for the determination of the major secondary metabolites in the olive leaf samples.
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D3.1</b> Report on the isotopic identity of Greek olive fruits.
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D3.2</b> Report on the fingerprinting of the microbial diversity (bacteria and yeasts) of Greek olive varieties
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D3.3</b> Report on the collection of identified microorganisms isolated from Greek olive varieties.
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D3.4</b> Report on the metabolic and technological potential of microorganisms, isolated from Greek olive varieties.
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D3.5</b> Report on the evolution of the microbial flora in the fermentation of Greek & Spanish-type edible olives
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D3.6</b> Report on the development of the most appropriate methodology for the determination of the major secondary metabolites in the edible olive samples
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D4.1</b> Report on the development of a specialized protocol for olive oil production
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D4.2</b> Report on the application of LC-UV/MS, NMR analytical methodologies of the collected olive oil samples
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D4.3</b> Report on the determination of qualitative and organoleptic characteristics in olive oil samples, according to EU regulation 2568/91.
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D5.1</b> Report on the determination of the isotopic identity of olive oil samples by geographical area
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D5.2</b> Report on the development of the specific genetic protocol for the identification of Greek olive oils
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D5.3</b> Report on the development of the multi-variety olive oil identification protocol
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D5.4</b> Report on the development of specific protocol for the detection of adulteration in olive oils, derived from different types
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D6.1</b> Report on the creation and establishment of a private protocol for the identification and the quality assurance of Greek olive varieties
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D6.2</b> Report on the creation and establishment of a private protocol for the quality and authenticity of edible olives
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D6.3</b> Report on the creation and establishment of a private protocol for the verification of the health claim requirements in olive oil meeting the EFSA criteria.
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D6.4</b> Report on the creation and establishment of a private protocol for the quality assurance of PDO & PGI olive oils
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D7.1</b> Report on the promotion of authenticated and tagged with health claim edible olive and olive oil products, at European and International Exhibitions
    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>D7.2</b> Report on the promotion of authenticated and tagged with health claim PDO & PGI olive oil products, at European and International Exhibitions
    </Typography>
                </li>
            </ul>

        </React.Fragment>
    )
}